import React from "react";
import { RightOutlined } from "@ant-design/icons";
import Manager from "../../../../../components/Manager";
import { useRedEnvelope } from "../../redEnvelope/RedEnvelopeContext";

// subType=6 红包预告
export default function RedPacketPreviewMessage({ msg }) {
  const { attach } = msg;
  const { getRedEnvelopeInfo, openRedEnvelopeAlert, handleRecord } = useRedEnvelope();
  return (
    <div
      className="imc-redpack-preview"
      onClick={() => {
        Manager.push({ event_id: attach?.event_id });
        getRedEnvelopeInfo(attach.redenvelope_id).then((data) => {
          if (data.is_pop_bullet) openRedEnvelopeAlert(data);
          else handleRecord(data);
        });
      }}
    >
      <div className="imc-redpack-preview-head">
        <img src="resources/251222/re_small.png" alt="" height={20} />
        <span className="imc-redpack-preview-title">红包预告</span>
      </div>
      <div className="imc-redpack-preview-desc">{attach?.preview_desc}</div>
      <div className="imc-redpack-preview-footer">
        <span>查看详情</span>
        <RightOutlined style={{ fontSize: 10, color: "#999" }} />
      </div>
    </div>
  );
}
